import { FormattedMessage, useIntl } from 'react-intl';
import { Setting } from 'Settings/components';
import styles from './PersonalSpaceSettings.module.scss';

const PersonalSpaceSettings = () => {
  const intl = useIntl();
  return (
    <div className={styles.root}>
      <Setting label={intl.formatMessage({ id: 'global.name' })} testId="space-name">
        <FormattedMessage id="spaces.personalSpace" />
      </Setting>
    </div>
  );
};

export default PersonalSpaceSettings;
